import { useQuery } from "@tanstack/react-query";
import API from "@/config/api";
import type { Brand, BrandMember, BrandDomain } from "@/types/brand";

export function useGetBrandById(id: number) {
  return useQuery({
    queryKey: ["brand", id],
    queryFn: async () => {
      const { data } = await API.main.get<{ data: Brand }>(`/brands/${id}`);
      return data.data;
    },
    enabled: Boolean(id),
  });
}
export function useGetBrandByDomain(domain:string) {
  return useQuery({
    queryKey: ["brand", domain],
    queryFn: async () => {
      const { data } = await API.main.get<{ data: Brand }>(`/brands/domain/${domain}`);
      return data.data;
    },
    enabled: Boolean(domain),
  });
}

export function useGetBrandMembers(brandId: number) {
  return useQuery({
    queryKey: ["brandMembers", brandId],
    queryFn: async () => {
      const { data } = await API.main.get<{ data: BrandMember[] }>(
        `/brands/${brandId}/members`,
      );
      return data.data;
    },
    enabled: Boolean(brandId),
  });
}

export function useGetBrandDomains(brandId: number) {
  return useQuery({
    queryKey: ["brandDomains", brandId],
    queryFn: async () => {
      const { data } = await API.main.get<{ data: BrandDomain[] }>(
        `/brands/${brandId}/domains`,
      );
      return data.data;
    },
    enabled: Boolean(brandId),
  });
}

export function useGetBrandRoles(brandId: number) {
  return useQuery({
    queryKey: ["brandDomains", brandId],
    queryFn: async () => {
      const { data } = await API.main.get<{ data: BrandDomain[] }>(
        `/brands/${brandId}/domains`,
      );
      return data.data;
    },
    enabled: Boolean(brandId),
  });
}
